import { ProcessRowPayload } from 'utils/processExcelTemplate';

export enum RepartoCapitalSubtype {
  REDUCCION_DE_CAPITAL = 'REDUCCION_DE_CAPITAL',
  DEVOLUCION_DE_APORTACIONES = 'DEVOLUCION_DE_APORTACIONES',
}

export const REPARTO_CAPITAL_SUBTYPE_OPTIONS = [
  {
    value: RepartoCapitalSubtype.REDUCCION_DE_CAPITAL,
    labelKey: 'admin.processes.repartoCapitalSubtype.REDUCCION_DE_CAPITAL',
  },
  {
    value: RepartoCapitalSubtype.DEVOLUCION_DE_APORTACIONES,
    labelKey: 'admin.processes.repartoCapitalSubtype.DEVOLUCION_DE_APORTACIONES',
  },
];

export enum ProcessOperationType {
  CAPITAL_CALL = 'CAPITAL_CALL',
  REPARTO_CAPITAL = 'REPARTO_CAPITAL',
  DEVOLUCION_INTERESES = 'DEVOLUCION_INTERESES',
  REPARTO_DIVIDENDO = 'REPARTO_DIVIDENDO',
  DISMINUCION_CAPITAL_CDI = 'DISMINUCION_CAPITAL_CDI',
  DISMINUCION_CAPITAL_SIN_CDI = 'DISMINUCION_CAPITAL_SIN_CDI',
}

export const PROCESS_OPERATION_TYPE_OPTIONS = [
  { value: ProcessOperationType.CAPITAL_CALL, labelKey: 'admin.processes.type.CAPITAL_CALL' },
  {
    value: ProcessOperationType.REPARTO_CAPITAL,
    labelKey: 'admin.processes.type.REPARTO_CAPITAL',
  },
  {
    value: ProcessOperationType.DEVOLUCION_INTERESES,
    labelKey: 'admin.processes.type.DEVOLUCION_INTERESES',
  },
  {
    value: ProcessOperationType.REPARTO_DIVIDENDO,
    labelKey: 'admin.processes.type.REPARTO_DIVIDENDO',
  },
  {
    value: ProcessOperationType.DISMINUCION_CAPITAL_CDI,
    labelKey: 'admin.processes.type.DISMINUCION_CAPITAL_CDI',
  },
  {
    value: ProcessOperationType.DISMINUCION_CAPITAL_SIN_CDI,
    labelKey: 'admin.processes.type.DISMINUCION_CAPITAL_SIN_CDI',
  },
];

export type AdminCreateProcessForm = {
  operationType: string
  promotionId: string
  /** Obligatorio si `operationType` es REPARTO_CAPITAL (envío en `api/process/run`). */
  repartoCapitalSubtype?: string
};

export type AdminCreateProcessPayload = {
  operationType: string
  promotionId: string
  investmentAccounts: string[]
};

export type ProcessEmailRecipient = {
  email: string
  accountId: number
};

export type AdminRunProcessPayload = {
  operationType: string
  promotionId: string
  data: ProcessRowPayload[]
  repartoCapitalSubtype?: RepartoCapitalSubtype
  emailSender?: string | null
  toEmails?: ProcessEmailRecipient[]
  ccEmails?: ProcessEmailRecipient[]
  emailSubject?: string | null
  emailBody?: string | null
  pdfRenderer?: string
};

export type ProcessDocumentItem = {
  fileName: string
  blobUrl: string
  downloadUrl: string
};

export type ProcessDocumentsResponse = {
  processId: string
  container: string
  files: ProcessDocumentItem[]
};
